import { get } from 'lodash';
import { createSelector } from 'reselect';
import { formValueSelector } from 'redux-form';

import { makeOptionsDataRemoveEmpty } from 'Common/FormHelper';
import { EXPORT_TOTALS_FORM_NAME } from 'Common/FormEnum';
import { ExportTotalsFieldEnum } from 'Common/FieldEnum';

const root = state => get(state, 'ExportTotalsState');

export const getFetching = state => get(root(state), 'fetching');
export const getFetchError = state => get(root(state), 'fetchError', null);

export const formSelector = formValueSelector(EXPORT_TOTALS_FORM_NAME);
export const getExportType = state =>
  formSelector(state, ExportTotalsFieldEnum.ExportType);
export const getHasReport = state => get(root(state), 'hasReport', null);

// breakfast items
export const getBreakfastItems = state =>
  get(root(state), 'breakfastItems', []);
export const getBreakfastOptions = createSelector(
  getBreakfastItems,
  breakfastItems => makeOptionsDataRemoveEmpty(breakfastItems, true)
);

// lunch items
export const getLunchItems = state => get(root(state), 'lunchItems', []);
export const getLunchOptions = createSelector(
  getLunchItems,
  lunchItems => makeOptionsDataRemoveEmpty(lunchItems, true)
);



// WEBPACK FOOTER //
// ./src/pages/exporttotals/state/selectors.js